// Resolves stored image URLs to fully-qualified, browser-loadable URLs.
//
// Why this exists:
//   The backend stores uploaded image URLs as `/uploads/<subdir>/<file>`
//   (e.g. `/uploads/admin/logo/logo_2026...png`) because internal helpers
//   check `url.startswith("/uploads/")` to detect locally-stored files.
//   The actual FastAPI serve route, however, lives at `/api/uploads/...`.
//
//   The Emergent platform routes `/api/...` to the backend pod and
//   everything else to the frontend pod, so a bare `<img src="/uploads/x">`
//   request goes to the frontend, which returns the SPA's index.html.
//   The browser receives `text/html` where it expected an image and
//   renders the broken-image glyph — which on cream/dark admin cards
//   reads as a SOLID BLACK SQUARE.
//
// Behaviour:
//   - Absolute http(s) URLs → returned unchanged (e.g. seeded Unsplash logos).
//   - `/api/...` paths → prefixed with REACT_APP_BACKEND_URL (no double-`/api`).
//   - `/uploads/...` paths → prefixed with REACT_APP_BACKEND_URL + `/api`
//     so they hit the proper FastAPI serve route.
//   - Anything else (data:, blob:, relative …) → returned as-is.
//
// Pure function, no React imports — safe to use in any context.
export const assetUrl = (path) => {
    if (!path || typeof path !== 'string') return '';
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('data:') || path.startsWith('blob:')) return path;
    const backend = process.env.REACT_APP_BACKEND_URL || '';
    if (path.startsWith('/api/')) return `${backend}${path}`;
    if (path.startsWith('/uploads/')) return `${backend}/api${path}`;
    return path;
};

export default assetUrl;
